import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as orgRepo from "@/stores/organizations/repository";
import { useOrganizationContext } from "@/lib/context/OrganizationContext";

interface CancelInviteParams {
  inviteId: number;
}

/**
 * Cancel a pending organization invitation (soft-cancel to status 'cancelled').
 *
 * Success/error toasts are surfaced by the caller so they can be localized; this
 * hook only performs the mutation and refreshes the org invites list.
 */
export const useCancelInvite = () => {
  const queryClient = useQueryClient();
  const { currentOrganization } = useOrganizationContext();

  return useMutation({
    mutationFn: async ({ inviteId }: CancelInviteParams) => {
      return orgRepo.cancelInvite(inviteId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["organization-invites", currentOrganization?.id],
      });
    },
  });
};
